import React from 'react';
import { getTemplate } from 'TRANSLATION';
const Content = getTemplate('hint/PEP');

export default function PEPHint() {
  return <Content />;
}
